import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/TableProductPage'
import { TableConfiguration } from '~/components/ProductPage/productTypes/table'

export default function TableConfiguratorPage() {
  return (
    <ProductPageLayout fullWidth showBreadcrumbs={false} showDescription={false}>
      <ProductPage components={TableConfiguration} name="homepage.configurator.table.title" />
    </ProductPageLayout>
  )
}
